import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useSocket } from '../../contexts/SocketContext';
import { GeneralRoom, AdminSupportInbox } from '../../components/common/ChatCore';

export default function AdminChat() {
  const { user } = useAuth();
  const { socket } = useSocket();
  const [tab, setTab] = useState('support');

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div>
          <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 24 }}>LIVE CHAT</h1>
          <p style={{ color: 'var(--text-secondary)', fontSize: 13, marginTop: 4 }}>Manage user conversations and general chat</p>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={() => setTab('support')} className={`btn btn-sm ${tab === 'support' ? 'btn-primary' : 'btn-secondary'}`}>📬 Support Inbox</button>
          <button onClick={() => setTab('general')} className={`btn btn-sm ${tab === 'general' ? 'btn-primary' : 'btn-secondary'}`}>🌐 General Chat</button>
        </div>
      </div>

      <div style={{ height: 'calc(100vh - 180px)', border: '1px solid var(--border)', borderRadius: 12, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
        {tab === 'support'
          ? <AdminSupportInbox socket={socket} currentUser={user} />
          : <GeneralRoom socket={socket} currentUser={user} compact={false} />
        }
      </div>
    </div>
  );
}
